<template>
  <v-app>
    <VictimListener v-if="authenticated"/>
    <Navigation v-if="authenticated"/>
    <AppBar/>
    <Body/>
    <Footer/>
  </v-app>
</template>


<script>
import AppBar from './components/structure/app-bar/AppBar';
import Navigation from './components/structure/side-bar/Navigation';
import Body from './components/structure/body/index';
import Footer from './components/structure/footer/index';
import VictimListener from './components/structure/listeners/VictimListener';

import Echo from 'laravel-echo';

import { mapGetters } from 'vuex'

export default {
  name: 'App',

  components: {
    AppBar,
    Navigation,
    Body,
    Footer,
    VictimListener
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
  }
};
</script>
